import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphIframe = ({ entity }) => {
  return (
    <Container className="ParagraphIframe">
      <div className="ParagraphIframe__wrapper">
        <iframe src={entity.getIn(['field_link', 0, 'uri'])} />
      </div>
    </Container>
  );
};

export default ParagraphIframe;
